// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Iq4u","top":"styles_top__1rFez"};